import { FC, useState } from "react";
// import { useIntl } from "react-intl";
import { Message } from "../../components/Message";
import InputSearch from "../../components/InputSearch";
import GeneralView from "./view/GeneralView";
import StatisticsView from "./view/StatisticsView";
import VisitorView from "./view/VisitorView";
import InvoicingView from "./view/InvoicingView";
import AutomaticMessageView from "./view/AutomaticMessageView";
import { useIntl } from "react-intl";

const DashboardPlansSeller: FC = () => {
  const [activeButton, setActiveButton] = useState("1");
  const intl = useIntl();

  const handleButtonClick = (id: string) => {
    setActiveButton(id);
  };

  let activeComponent;
  switch (activeButton) {
    case "1":
      activeComponent = <GeneralView />;
      break;
    case "2":
      activeComponent = <StatisticsView />;
      break;
    case "3":
      activeComponent = <AutomaticMessageView />;
      break;
    case "4":
      activeComponent = <VisitorView />;
      break;
    case "5":
      activeComponent = <InvoicingView />;
      break;
    default:
      activeComponent = null;
      break;
  }

  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle> */}
      {/* begin::Row */}
      <div className="row g-5 g-xl-12 mb-5">
        {/* begin::search */}
        <InputSearch />
        {/* end::search */}

        {/* begin::topBar */}
        <div className="col-md-3 col-lg-3 col-xl-3 col-xxl-3 overflow-auto w-100">
          <div className="list-group gap-2 flex-row">
            <button
              id="1"
              type="button"
              className={`btn btn-secondary text-uppercase w-100 fw-bold ${
                activeButton === "1" ? "active" : ""
              }`}
              onClick={() => handleButtonClick("1")}
            >
              {intl.formatMessage({
                id: "MENU.DASHBOARD_PLANS_SALES.GENERAL",
              })}
            </button>
            <button
              id="2"
              type="button"
              className={`btn btn-secondary text-uppercase w-100 fw-bold ${
                activeButton === "2" ? "active" : ""
              }`}
              onClick={() => handleButtonClick("2")}
            >
              {intl.formatMessage({
                id: "MENU.DASHBOARD_PLANS_SALES.STATISTICS",
              })}
            </button>
            <button
              id="3"
              type="button"
              className={`btn btn-secondary text-uppercase w-100 fw-bold ${
                activeButton === "3" ? "active" : ""
              }`}
              onClick={() => handleButtonClick("3")}
            >
              {intl.formatMessage({
                id: "MENU.DASHBOARD_PLANS_SALES.AUTMATIC_MESSAGE",
              })}
            </button>
            <button
              id="4"
              type="button"
              className={`btn btn-secondary text-uppercase w-100 fw-bold ${
                activeButton === "4" ? "active" : ""
              }`}
              onClick={() => handleButtonClick("4")}
            >
              {intl.formatMessage({
                id: "MENU.DASHBOARD_PLANS_SALES.VISITOR",
              })}
            </button>
            <button
              id="5"
              type="button"
              className={`btn btn-secondary text-uppercase w-100 fw-bold ${
                activeButton === "5" ? "active" : ""
              }`}
              onClick={() => handleButtonClick("5")}
            >
              {intl.formatMessage({
                id: "MENU.DASHBOARD_PLANS_SALES.INVOICING",
              })}
            </button>
          </div>
        </div>
        {/* end::topBar */}
        <Message />

        {activeComponent}
      </div>
      {/* end::Row */}
    </>
  );
};

export { DashboardPlansSeller };
